export const INDUSTRIES = [
  {
    slug: "startups",
    name: "Startups",
    description:
      "Entity structuring, registrations, compliance calendars, bookkeeping discipline and financial readiness for early-stage ventures.",
  },
  {
    slug: "smes",
    name: "SMEs",
    description:
      "Ongoing accounting, GST and income tax compliance, audits and management reporting for small and medium enterprises.",
  },
  {
    slug: "manufacturing",
    name: "Manufacturing",
    description:
      "Accounting for production businesses, GST on goods, stock and process audits, and working-capital oriented reporting.",
  },
  {
    slug: "trading",
    name: "Trading",
    description:
      "High-volume transaction accounting, GST compliance for goods, inventory reconciliation and tax audit support for trading businesses.",
  },
  {
    slug: "retail",
    name: "Retail",
    description:
      "Point-of-sale aligned accounting, GST returns, Shops and Establishments compliance and periodic reporting for retail operations.",
  },
  {
    slug: "e-commerce",
    name: "E-commerce",
    description:
      "Marketplace settlement reconciliation, TCS under GST, multi-state compliance and returns for online sellers and D2C brands.",
  },
  {
    slug: "it-software",
    name: "IT & Software",
    description:
      "Compliance for services businesses, export of services documentation, LUT advisory and accounting for technology companies.",
  },
  {
    slug: "professional-services",
    name: "Professional Services",
    description:
      "Income tax, GST on services, bookkeeping and advisory for consultants, agencies, architects and other professionals.",
  },
  {
    slug: "real-estate",
    name: "Real Estate",
    description:
      "RERA advisory and compliance, project accounting, GST on real estate transactions and due diligence support.",
  },
  {
    slug: "construction",
    name: "Construction",
    description:
      "Works-contract GST treatment, project-wise accounting, TDS compliance and audit support for contractors and developers.",
  },
  {
    slug: "exporters-importers",
    name: "Exporters & Importers",
    description:
      "LUT filing, export-import documentation, foreign remittance advisory and GST refund assistance for cross-border trade.",
  },
  {
    slug: "healthcare",
    name: "Healthcare",
    description:
      "Accounting and tax compliance for clinics, diagnostic centres and healthcare professionals, including applicable exemptions.",
  },
  {
    slug: "education",
    name: "Education",
    description:
      "Compliance and accounting support for coaching classes, training institutes and education service providers.",
  },
  {
    slug: "creative-digital",
    name: "Creative & Digital Businesses",
    description:
      "Bookkeeping, GST and income tax support for creators, studios, influencers and digital-first businesses.",
  },
  {
    slug: "individuals-professionals",
    name: "Individuals & Professionals",
    description:
      "Income tax return filing, capital gains computation, tax planning and notice assistance for salaried individuals and professionals.",
  },
  {
    slug: "nri-clients",
    name: "NRI Clients",
    description:
      "Residential status evaluation, India-sourced income taxation, property transaction compliance and repatriation-related advisory.",
  },
];
